import axios from "axios"
import { liveURL } from ".././constants/Consts"

const MAIN_URL = `${liveURL}/v1/adminPortal`; 
const GET_ADMIN_BY_TOKEN=`${MAIN_URL}/getAdminByToken`

 
 //get userdetail
 export async function getAdminByToken(token) {
  console.log(token)
    try {
      const response = await axios.get(GET_ADMIN_BY_TOKEN, {
        headers: {
          token: token,
        },
        withCredentials: true,  // Add this line
      });
      return response.data;
    } catch (error) {
      return console.log(error);
    }
  }